var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeimage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TimeImage") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    d: "m14.59961,6zm-13.09961,12.5l0,-2l4.7002,-4.80078l5.62793,5.90039l3.875,-4.09961l2.89648,2.90039l0,2.09961l-17.09961,0zm17,-17l0,12.69922l-2.7998,-2.90039l-3.9004,4.10156l-5.5996,-5.90039l-4.7002,4.79883l0,-12.79883l17,0zm-18.5,-1.5l0,20l20,0l0,-20l-20,0z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.753748 0 0 0.552925 0.946515 0.803548)",
    stroke: "null",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Noto Sans JP",
    fontSize: 24,
    strokeWidth: 0,
    fill: "#000000",
    id: "svg_2",
    y: 18.8106,
    x: 7.33715
  }, "T"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeimage);
export default __webpack_public_path__ + "static/media/timeimage.733318d57f090fb06b2835825bfba3f6.svg";
export { ForwardRef as ReactComponent };